// extracted by mini-css-extract-plugin
export default {"ChoiceWidget":"styles_ChoiceWidget__pbLlS","selected":"styles_selected__8bUCI","changed":"styles_changed__P-y31","slidein":"styles_slidein__tys3X"};